import React, { useState } from 'react';
import './NewInsurance.css';

const NewInsurance = ({ setShowSaved, selectedDoctor, setEditBookArray, editBookArray, manualSetDoctors, setSelectedItem }) => {
    const [newInsurance, setNewInsurance] = useState('');
    const [errorInsurance, setErrorInsurance] = useState('');
    const [locationsToSend, setLocationsToSend] = useState([]);
    const [bodilyPartsToSend, setBodilyPartsToSend] = useState([]);

    const csrfToken = localStorage.getItem('csrfToken');
    const handleChange = (event) => {
        setErrorInsurance('');
        setNewInsurance(event.target.value);
    };

    const handleClick = () => {




        fetch(`https://apps.laoss.com/api/v1/new_insurance`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken
            },
            body: JSON.stringify({ doctor_id: selectedDoctor.doctor.id, insurance: newInsurance.trimRight() })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            console.log('new insurance responseJson', responseJson);
            if (responseJson.message) {
                console.error('Error 1 /new_insurance:');
                setErrorInsurance(responseJson.message);
            } else {
                const bookArray = [
                    {
                        title: 'Age Groups',
                        lines: responseJson.doctor.age_groups,
                        icon: 'fa-calendar-alt'
                    },
                    {
                        title: 'Body Parts',
                        lines: responseJson.doctor.bodily_parts,
                        icon: 'fa-universal-access'
                    },
                    {
                        title: 'Insurances',
                        lines: responseJson.doctor.insurances,
                        icon: 'fa-file-contract'
                    },
                    {
                        title: 'Offices',
                        lines: responseJson.doctor.offices,
                        icon: 'fa-building'
                    }
                ]
                

                const forManualDoctors = responseJson.doctor.doctors_scheduler;

                const updatedBookArray = editBookArray.map((book) => {
                    if (book.title === 'Insurances') {
                        const updatedLines = book.lines.map((line) => {
                            const insurance = responseJson.doctor.insurances.find((ag) => ag.name === line.name);
                            if (insurance) {
                                return {
                                    ...line,
                                    covered: true,
                                    
                                };
                            }
                            return line;
                        });
                        
                        responseJson.doctor.insurances.forEach((insurance) => {
                            const existingLine = updatedLines.find((line) => line.name === insurance.name);
                            if (!existingLine) {
                                updatedLines.push({
                                    name: insurance.name,
                                    id: insurance.id,
                                    covered: true

                                });
                            }
                        });
                        
                        return {
                            ...book,
                            lines: updatedLines
                        };
                    }
                    return book;
                });
                
                
                setEditBookArray(updatedBookArray);
                
                setLocationsToSend([]);
                setBodilyPartsToSend([]);
                manualSetDoctors(forManualDoctors);
                setShowSaved(true); // Show the "Saved" message
                setSelectedItem(null);
                setNewInsurance('');
                setTimeout(() => {
                    setShowSaved(false); // Hide the "Saved" message after 1 second
                }, 1500);
            }
        })
        .catch(error => {
            console.error('Error 2 new_insurance', error);
        })
    };

    const handleKeyDown = (event) => {

        if (newInsurance && event.key === 'Enter') {
            handleClick();
        }
    };

    return (
        <div className="new-insurance">
            {errorInsurance && <p style={{ color: 'red', textShadow: 'none', margin: '0px 5px 0px 5px', padding: '0px 5px 0px 5px' }}>{errorInsurance}</p>}
            <input
                type="text"
                value={newInsurance}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder="Enter new Insurance"
                style={{ height: '28px', fontSize: '1rem', width: '70%', margin: '0px 10px 0px 0px', padding: '0px 0px 0px 15px' }}


            />
            <button onClick={handleClick}>Add</button>
        </div>
    );
};

export default NewInsurance;
